import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const { user } = useAuth();
  const [projects, setProjects] = useState([]);
  const [emails, setEmails] = useState([]);
  const [usage, setUsage] = useState({ today: 0, limit: 10 });

  useEffect(() => {
    if (user) {
      loadUserData();
    }
  }, [user]);

  const loadUserData = () => {
    const storedProjects = localStorage.getItem(`projects_${user.id}`);
    const storedEmails = localStorage.getItem(`emails_${user.id}`);
    const storedUsage = localStorage.getItem(`usage_${user.id}`);

    if (storedProjects) setProjects(JSON.parse(storedProjects));
    if (storedEmails) setEmails(JSON.parse(storedEmails));
    if (storedUsage) setUsage(JSON.parse(storedUsage));
  };

  const saveProject = (project) => {
    const newProject = {
      id: Date.now(),
      userId: user.id,
      ...project,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };

    const updatedProjects = [...projects, newProject];
    setProjects(updatedProjects);
    localStorage.setItem(`projects_${user.id}`, JSON.stringify(updatedProjects));
    return newProject;
  };

  const saveEmail = (email, projectId = null) => {
    const newEmail = {
      id: Date.now(),
      projectId,
      userId: user.id,
      ...email,
      createdAt: new Date().toISOString()
    };

    const updatedEmails = [...emails, newEmail];
    setEmails(updatedEmails);
    localStorage.setItem(`emails_${user.id}`, JSON.stringify(updatedEmails));
    return newEmail;
  };

  const incrementUsage = () => {
    const today = new Date().toDateString();
    const newUsage = { ...usage };
    
    if (usage.date !== today) {
      newUsage.today = 1;
      newUsage.date = today;
    } else {
      newUsage.today += 1;
    }

    setUsage(newUsage);
    localStorage.setItem(`usage_${user.id}`, JSON.stringify(newUsage));
    return newUsage;
  };

  const value = {
    projects,
    emails,
    usage,
    saveProject,
    saveEmail,
    incrementUsage
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};